module.exports = __webpack_public_path__ + "img/0Q3A3001_FoamcoreMatted.798904d0.jpg";